import { FunctionComponent, useCallback } from 'react'
import styled, { css } from 'styled-components'

import { type Image } from '@utils/cook/types'
import { CookWidget, JSONTypeForCookWidget } from '@widgets/types'
import { mobileCSS } from '@measures/responsive'

import useIsAuthResolved from '@hooks/useIsAuthResolved'
import useFeatureFlagsSkeleton from '@hooks/useFeatureFlagsSkeleton'
import useUser from '@hooks/useUser'

import FollowMyTeamOverviewComponent from '@components/FollowMyTeamOverview'
import FollowMyTeamOverviewBanner from '@components/FollowMyTeamOverview/FollowMyTeamOverviewBanner'

export interface FollowMyTeamOverviewAPIProps {
  title: string
  backgroundImage: Image<'16_9'>
  image: Image<'free'>
}

const FollowMyTeamOverviewWrapper = styled.div`
  height: 80px;

  ${mobileCSS(css`
    height: 64px;
  `)};
`

const FollowMyTeamOverview: FunctionComponent<FollowMyTeamOverviewAPIProps> = (
  props
) => {
  const { title, backgroundImage, image } = props

  const { isFollowMyTeamEnabled } = useFeatureFlagsSkeleton()
  const user = useUser()
  const isAuthResolved = useIsAuthResolved()

  const handleBannerClick = useCallback(() => {
    console.log('banner clicked')
  }, [])

  const handleSettingsClick = useCallback(() => {
    console.log('settings clicked')
  }, [])

  const handleAddTeamClick = useCallback(() => {
    console.log('add team clicked')
  }, [])

  if (!isFollowMyTeamEnabled) {
    return null
  }

  return (
    <FollowMyTeamOverviewWrapper>
      {isAuthResolved ? (
        !!user ? (
          <FollowMyTeamOverviewComponent
            backgroundImage={backgroundImage}
            image={image}
            title={title}
            onBannerClick={handleBannerClick}
            onSettingsClick={handleSettingsClick}
            onAddTeamClick={handleAddTeamClick}
          />
        ) : (
          <FollowMyTeamOverviewBanner
            backgroundImage={backgroundImage}
            image={image}
            title={title}
            onClick={handleBannerClick}
          />
        )
      ) : null}
    </FollowMyTeamOverviewWrapper>
  )
}

const widget = {
  kind: ['follow-my-team-overview'],
  component: FollowMyTeamOverview,
} as const satisfies CookWidget

export type WidgetType = typeof widget

export type JSONWidgetType = JSONTypeForCookWidget<WidgetType>

export default widget
